type Step = {
  number: number;
  label: string;
};

interface WizardStepsProps {
  steps?: Step[];
  currentStep: number;
}

const defaultSteps: Step[] = [
  { number: 1, label: 'Select File' },
  { number: 2, label: 'Encrypt' },
  { number: 3, label: 'Add Recipients' },
  { number: 4, label: 'Upload' },
  { number: 5, label: 'Summary' },
];

export function WizardSteps({
  steps = defaultSteps,
  currentStep,
}: WizardStepsProps) {
  return (
    <div className="wizard-steps">
      {steps.map(step => {
        const isActive = step.number === currentStep;
        const isCompleted = step.number < currentStep;

        return (
          <div
            key={step.number}
            className={`wizard-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
          >
            {step.number} {step.label}
          </div>
        );
      })}
    </div>
  );
}

// Quick Share steps (no encryption, no login)
export const quickShareSteps: Step[] = [
  { number: 1, label: 'Select File' },
  { number: 2, label: 'Confirm' },
  { number: 3, label: 'Upload' },
  { number: 4, label: 'Summary' },
];

// Store File steps (encrypt but no recipient)
export const storeSteps: Step[] = [
  { number: 1, label: 'Select File' },
  { number: 2, label: 'Encrypt' },
  { number: 3, label: 'Upload' },
  { number: 4, label: 'Summary' },
];
